package ai.flowstorm.studio.ui.design

import ai.flowstorm.common.setProperty
import ai.flowstorm.common.ui.EntityTable
import ai.flowstorm.studio.model.Voice
import ai.flowstorm.studio.resources.space.VoiceResource
import io.kvision.i18n.tr
import io.kvision.tabulator.ColumnDefinition
import io.kvision.tabulator.Layout
import io.kvision.tabulator.TabulatorOptions
import io.kvision.utils.obj
import io.kvision.utils.px

class VoiceTable : EntityTable<Voice>(
    caption = "Voice",
    model = VoiceResource,
    tabulatorOptions = TabulatorOptions(
        layout = Layout.FITCOLUMNS,
        columns = listOf(
            ColumnDefinition(tr("Name"), Voice::label.name, width = "55%"),
            ColumnDefinition(tr("Locale"), FIELD_LOCALE, width = "20%"),
            ColumnDefinition(tr("Provider"), FIELD_PROVIDER, width = "23%")
        )
    ),
    dataExtractor = {
        obj {
            setProperty(this, it::label)
            this[FIELD_LOCALE] = it.ttsConfig.locale
            this[FIELD_PROVIDER] = it.ttsConfig.provider
        }
    },
    entityComponentFactory = { VoiceEditor() },
    entityFactory = { Voice() },
    searchEnabled = true,
    seekEnabled = true,
    splitMode = true,
    tabWidth = 500.px,
    className = "content-panel",
) {
    companion object {
        const val FIELD_LOCALE = "locale"
        const val FIELD_PROVIDER = "provider"
    }
}
